module.exports = __webpack_public_path__ + "static/media/labas.a2c5af40.jpg";